import {createAction} from 'typesafe-actions';

import * as Types from './types';
import * as PanelTypes from '../panel/types';
import * as PanelBankConfigTypes from '../panelBankConfig/types';
import {PanelBankFlowSectionConfig} from '../../../util/panelbank';
import {GridLayout} from '../../../util/panelbankGrid';

// Toggle between 'flow' and 'grid' modes
export const toggleType = createAction(
  '@view/panelBankSectionConfig/toggleType',
  action => (ref: Types.Ref) => action({ref})
);

// Toggle expanded/collapsed state
export const toggleIsOpen = createAction(
  '@view/panelBankSectionConfig/toggleIsOpen',
  action => (ref: Types.Ref) => action({ref})
);

// Rename the section
export const updateName = createAction(
  '@view/panelBankSectionConfig/updateName',
  action => (ref: Types.Ref, newName: string) => action({ref, newName})
);

// Handles box-resizing and changing rows per page in flow sections ('standard layout')
export const updateFlowConfig = createAction(
  '@view/panelBankSectionConfig/updateFlowConfig',
  action => (
    ref: Types.Ref,
    newFlowConfig: Partial<PanelBankFlowSectionConfig>
  ) => action({ref, newFlowConfig})
);

// Handles saving box layout in grid sections ('custom layout')
export const setGridLayout = createAction(
  '@view/panelBankSectionConfig/setGridLayout',
  action => (ref: Types.Ref, newGridLayout: GridLayout) =>
    action({ref, newGridLayout})
);

// Add a panel to this section
export const addPanel = createAction(
  '@view/panelBankSectionConfig/addPanel',
  action => (
    ref: Types.Ref,
    panelRef: PanelTypes.Ref, // the panel we're adding
    fatPanel?: boolean
  ) => action({ref, panelRef, fatPanel})
);

export const deletePanel = createAction(
  '@view/panelBankSectionConfig/deletePanel',
  action => (
    ref: Types.Ref,
    panelRef: PanelTypes.Ref, // the panel we're deleting
    panelBankConfigRef?: PanelBankConfigTypes.Ref // the panel bank config ref (optional, only neccessary if we're dealing with hidden panels)
  ) => action({ref, panelRef, panelBankConfigRef})
);

export const duplicatePanel = createAction(
  '@view/panelBankSectionConfig/duplicatePanel',
  action => (
    ref: Types.Ref,
    panelRef: PanelTypes.Ref // the panel we're duplicating
  ) => action({ref, panelRef})
);
